import { useQuery } from "@apollo/client";
import { GetCheckoutCartDocument } from "../../../../graphql/queries/__generated__/checkout.query";
import { isServerCheckoutEnabled } from "../../../../utils/featureFlags";
import { useAppSelector } from "../../../../redux/hook";
import { RESELLER_TOKEN } from "../../../../utils/constants";

/**
 * Header cart-badge count (docs/server-checkout-migration.md P4.2).
 * Flag on → line-item count from the cached server cart (kept fresh by every
 * checkout mutation via the shared fragment); flag off → the legacy Redux
 * cart, unchanged. Skips the query for guests so logged-out browsing never
 * fires (failing) cart requests.
 */
const useCartItemCount = (): number => {
  const serverCheckout = isServerCheckoutEnabled();
  const { cart: reduxCart } = useAppSelector((state) => state.cart);
  const hasToken = Boolean(window.localStorage.getItem(RESELLER_TOKEN));
  const { data } = useQuery(GetCheckoutCartDocument, {
    skip: !serverCheckout || !hasToken,
    fetchPolicy: "cache-first",
    errorPolicy: "all",
  });
  if (serverCheckout) {
    return data?.getCheckoutCart?.items.length ?? 0;
  }
  return reduxCart?.products?.length ?? 0;
};

export default useCartItemCount;
